import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { isSubmenuInPermissions } from '@utils/static/commonUtils';

function SubMenu(props: any) {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const clickRoute = (route: any) => {
        try {
            // if (route) {
            //     history.push(match.url + route);
            // }

            setShow(!show);
        } catch (error) {}
    };

    return (
        <React.Fragment>
            <li className={`${props.menu?.subMenu?.length > 0 ? 'parent_menu_box' : ''} ${show ? '' : 'close_it'}`}>
                {props?.menu?.route && props?.permission?.includes(props?.menu?.route) ? (
                    <NavLink to={props.menu.route}>
                        <span className="icon_box">
                            <img className="img-fluid icon_img" src={props.menu.activeImage} alt="" />
                            <img className="img-fluid icon_img_active" src={props.menu.inactiveImage} alt="" />
                        </span>
                        {props.menu.title}
                    </NavLink>
                ) : isSubmenuInPermissions(props?.menu?.subMenu, props?.permission) ? (
                    <a href="javascript:void(0)" onClick={() => clickRoute(props.menu.route)}>
                        <span className="icon_box">
                            <img className="img-fluid icon_img" src={props.menu.activeImage} alt="" />
                            <img className="img-fluid icon_img_active" src={props.menu.inactiveImage} alt="" />
                        </span>
                        {props.menu.title}
                    </a>
                ) : (
                    ''
                )}

                {props.menu?.subMenu?.length > 0 && (
                    <ul className="sub_menu_box" style={{ display: show ? 'block' : 'none' }}>
                        {(props.menu?.subMenu.filter(item => props?.permission?.includes(item.route)) || []).map(
                            (m: any, n: any) => (
                                <li key={n}>
                                    <NavLink to={m.route}>{m.title}</NavLink>
                                </li>
                            ),
                        )}
                    </ul>
                )}
            </li>
        </React.Fragment>
    );
}

export default SubMenu;
